/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Enum from 'galax/enum/route';

import BuildingAttack from 'astro/config/command/building.attack';
import BuildingCreate from 'astro/config/command/building.create';
import BuildingUpgrade from 'astro/config/command/building.upgrade';

import UnitAttack from 'astro/config/command/unit.attack';
import UnitCreate from 'astro/config/command/unit.create';


let Config = {};


Config[Enum.BuildingAttack]      = BuildingAttack;
Config[Enum.BuildingCreateList]  = BuildingCreate;
Config[Enum.BuildingCreateType]  = BuildingCreate;
Config[Enum.BuildingUpgrade]     = BuildingUpgrade;

Config[Enum.UnitAttack]          = UnitAttack;
Config[Enum.UnitCreateList]      = UnitCreate;
Config[Enum.UnitCreateType]      = UnitCreate;


export default Config;
